import { action } from 'satcheljs';

export const manageDomainClick = action('manageDomainClick');
